<template>
  <tr>
    <td>{{item.id}}</td>
    <td>{{item.created}}</td>
    <td>{{item.warehouse_name}}</td>
    <td>{{item.ean}}</td>
    <td>{{item.sku}}</td>
    <td>{{item.product_name}}</td>
    <td>{{item.movement_type}}</td>
    <td><div class="float-right">{{item.change_amount}}</div></td>
    <td><div class="float-right">{{item.old_stock}}</div></td>
    <td><div class="float-right">{{item.new_stock}}</div></td>
    <td><div class="float-right">{{item.purchase_price}}</div></td>
    <td>{{item.comment}}</td>
    <td>{{item.ordernumber}}</td>
  </tr>
</template>

<script>
export default {
  name: 'StockHistoryRow',
  props: ['item']
}
</script>



// WEBPACK FOOTER //
// src/components/StockHistoryRow.vue